// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"ViewButton_pattern-gradient__EigXB","button":"ViewButton_button__Sdvy+","selected":"ViewButton_selected__t9l+5"};